<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">学生作品</span>

    <div style="margin-top:30px;">
      <el-cascader
        @change="sele_change"
        clearable
        placeholder="请选择学生"
        filterable
        v-model="value"
        :options="options"
        :props="{ label: 'Name', value: 'Name' }"
      ></el-cascader>

      <el-select
        v-if="false"
        clearable
        v-model="value_tag"
        placeholder="请选择类型"
        style="margin-left:20px;"
      >
        <el-option
          v-for="item in options_tag"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button
        size="mini"
        type="primary"
        icon="el-icon-search"
        style="margin-left:30px;"
        @click="search"
      >
        搜索
      </el-button>
    </div>

    <ul>
      <li
        v-for="(item, index) in scratch_list"
        :key="index"
        @click="to_work(item)"
      >
        <img :src="'https:/' + item.Image.Url" />
        <el-button
          @click.stop="delete_work(item.Id, index)"
          type="danger"
          icon="el-icon-delete"
          circle
        ></el-button>
        <div class="text">
          <p>学生：{{ item.User.Nickname }}</p>
          <p>作品：{{ item.WorkName }}</p>
          <p>日期：{{ item.CreatedAt }}</p>
        </div>
      </li>
    </ul>

    <div style="margin-top:20px;">
      <el-table
        v-if="false"
        class="class_table_data_style"
        :data="scratch_list"
        border
        stripe
      >
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="CreatedAt" label="创建时间"></el-table-column>
        <el-table-column
          prop="User.Nickname"
          label="作品姓名"
        ></el-table-column>
        <el-table-column prop="WorkName" label="作品名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-s-promotion"
              size="mini"
              @click="to_work(scope.row)"
            >
              查看
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_work(scope.row.Scratch.Id, scope.$index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination
      style="padding: 30px 0px; float:right;"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[40, 60, 80]"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import { deleteScratch, get_management_scratch_api } from "@/api/scratch.js";
import { get_class_api } from "@/api/home.js";
import { get_add_principal } from "@/api/admin.js";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    loading,
  },
  data() {
    return {
      scratch_list: [],
      class_table_data: [], //班级表格数据
      student_table: [], //学生表格数据
      tag_id: "",
      tag: "",
      options: [],
      options_tag: [
        {
          value: "游戏",
          label: "游戏",
        },
        {
          value: "音乐",
          label: "音乐",
        },
        {
          value: "动画",
          label: "动画",
        },
        {
          value: "模拟",
          label: "模拟",
        },
        {
          value: "搞笑",
          label: "搞笑",
        },
        {
          value: "故事",
          label: "故事",
        },
        {
          value: "互动编程手柄",
          label: "互动编程手柄",
        },
      ],
      value: "",
      value_tag: "",
      offset: 0,
      limit: 40,
      total: 0, //总数
      loading_ok: "",
    };
  },

  created() {
    // 获取班级
    get_class_api(this.current).then((res) => {
      this.class_table_data = res.data;
      res.data.forEach((r, i) => {
        let data = {
          domain: {
            group: "CLASS",
            name: r.Slug,
          },
          subject: {
            group: "ROLE",
            name: "STUDENT",
          },
        };

        // 获取班级下面的学生
        get_add_principal(data).then((v) => {
          r.children = v.data;
          if (res.data.length == i + 1) {
            this.options = res.data;
          }
        });
      });
    });

    this.search();
  },

  methods: {
    sele_change(v) {
      if (v != undefined) {
        this.value = v[1];
      } else {
        this.value = "";
      }
    },

    //搜索
    search() {
      this.scratch_list = [];
      get_management_scratch_api(this.value, this.offset, this.limit).then(
        (res) => {
          let arr = [];
          this.total = res.data.Total;
          if (res.data.Results[0].Scratch) {
            if (this.value_tag) {
              res.data.Results.forEach((l) => {
                if (l.Community != null) {
                  if (l.Community.Tag == this.value_tag) {
                    arr.push(l);
                  }
                }
              });
            }

            if (this.value_tag) {
              arr.forEach((value, i) => {
                this.scratch_list.push(value.Scratch);

                if (arr.length == i + 1) {
                  this.$forceUpdate();
                }
              });
            } else {
              res.data.Results.forEach((value, i) => {
                this.scratch_list.push(value.Scratch);
                if (res.data.Results.length == i + 1) {
                  this.$forceUpdate();
                }
              });
            }
          } else {
            res.data.Results.forEach((s, k) => {
              s.CreatedAt = this.filters.vdateAdd(s.CreatedAt);
              if (res.data.Results.length == k + 1) {
                this.loading_ok = false;
                this.$forceUpdate();
                this.scratch_list = res.data.Results;
                console.log(this.scratch_list);
              }
            });
          }
        }
      );
    },

    //进入作品
    to_work(value) {
      var url = "/scratch/?stageArea=false&id=" + value.Id;
      window.open(url);
    },

    //删除作品
    delete_work(id, index) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          deleteScratch(id).then(() => {
            this.search();
            this.$message.success("删除成功！");
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    //分页
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },

    //分页
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.limit;
      this.search();
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
    }
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width:100%;
     li {
       margin-top:20px;
       width:18.4%;
       height:180px;
       border:1px solid #eee;
       border-radius:6px;
       position:relative;
       border:1px solid #eee;
       position:relative;
       overflow: hidden;
       cursor: pointer;
       .el-button {
         position:absolute;
         right:-100px;
         top:-14px;
         transition: all 0.3s;
       }
       .text {
         position:absolute;
         bottom:-40px;
         background:rgba(0,0,0,0.8);
         width:100%;
         transition: all 0.3s;
         p {
           color:#fff;
           padding:4px;
           font-size:12px;
         }
       }
       img {
            height:100%;
            transition: all 0.3s;
          }
       .title {
            margin-top:16px;
            text-align:center;
            color:#333;
            font-size:14px;
        }
        .tab_box_button_div {
           width:100%;
           position:absolute;
           bottom: 0%;
           display: flex;
           justify-content: space-around;
           border-top:1px solid #eee;
           .el-button {
             width:100%
             height:30px;
             border-radius:0;
           };
        }
     }
     li:hover > .text {
         bottom:0px;
       }
       li:hover > .el-button  {
         top:0px;
         right:0px;
       }
       li:hover > img  {
         height:130%;
       }
}
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .question_bank_but {
       margin-bottom:20px;
       margin-top:10px;
    }
</style>
